import React from "react";
import styled from "styled-components";
import { extractBasedOnSymbology } from "../../helpers/extractBasedOnSymbologyUtils";
import { SymbologyType } from "../../types/SymbologyType";
import { useHDIScanner } from "../../hooks/useHDIScanner";

const InfoContainer = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;

const InfoHeader = styled.h3`
  margin: 0 0 10px 0;
`;

const InfoParagraph = styled.p`
  margin: 5px 0;
  word-wrap: break-word;
  max-width: 100%;
`;

const InfoValue = styled.span`
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  word-wrap: break-word;
`;

interface InfoBoxProps {
  title: string;
  value: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ title, value }) => {
  return (
    <InfoParagraph>
      <strong>{title}: </strong> <InfoValue>{value}</InfoValue>
    </InfoParagraph>
  );
};

const HDIScannerDebugPage: React.FC = () => {
  const [scannedValue, setScannedValue] = React.useState<string>("");
  const [lastScanTime, setLastScanTime] = React.useState<string>("");
  const [barcodeFormat, setBarcodeFormat] =
    React.useState<SymbologyType>("UNKNOWN");
  const [extractedProductId, setExtractedProductId] =
    React.useState<string>("");

  const handleScanEvent = (
    scannedBarcode: string,
    symbologyFormat: SymbologyType
  ) => {
    setScannedValue(scannedBarcode);
    setBarcodeFormat(symbologyFormat);
    setLastScanTime(new Date().toLocaleTimeString());
    // Handle unsupported symbologies
    if (symbologyFormat === "UNKNOWN" || symbologyFormat === "QR_CODE") {
      console.warn(
        "Unsupported symbology scanned:",
        symbologyFormat,
        scannedBarcode
      );
      return;
    }
    const extractedInformation = extractBasedOnSymbology(
      symbologyFormat,
      scannedBarcode
    );
    setExtractedProductId(extractedInformation.articleNumber);
  };

  useHDIScanner(handleScanEvent);
  return (
    <div style={{ padding: "20px" }}>
      <InfoContainer>
        <InfoHeader>Scanner Status</InfoHeader>
        <InfoBox title="Status" value="Ready for keyboard wedge input" />
        <InfoBox title="Mode" value="Keyboard wedge mode" />
      </InfoContainer>
      <InfoContainer>
        <InfoHeader>Scanned Information</InfoHeader>
        <div>
          <InfoBox title="Scanned Value" value={scannedValue} />
          <InfoBox title="Barcode Format" value={barcodeFormat} />
          <InfoBox title="Last Scan Time" value={lastScanTime} />
          <InfoBox
            title="Extracted Product ID"
            value={extractedProductId || "N/A"}
          />
        </div>
      </InfoContainer>
    </div>
  );
};

export default HDIScannerDebugPage;
